/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

function Register({BASEURL}) {
  const location = useLocation();
  const role = location.state?.role;
  const site = location.state?.site || [];
  // console.log(site)
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [roles, setRoles] = useState([]);
  const [sites, setSites] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedSite, setSelectedSite] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const [kagalScreen, setKagalScreen] = useState({ Overview: false, Solar: false, Wind: false, Genset: false, Ess: false, Mains: false, Biogas: false, Alert: false });
  const [cmklScreen, setcmklScreen] = useState({ Overview: false, Solar: false, Genset: false, Mains: false, Alert: false });
 const url = 'http://localhost:5002/cred'
  // console.log(role)

  useEffect(() => {
    axios.get(`${url}/role`)
      .then((response) => setRoles(response.data))
      .catch((err) => console.error(err));

    axios.get(`${url}/site`)
      .then((response) => setSites(response.data))
      .catch((err) => console.error(err));

  }, []);

  const handleRegister = async () => {
    setError(null);
    if (selectedRole === 'User' || selectedRole === 'Admin') {
      if (!selectedSite) {
        return setError("Please Select the Site")
      }
    }

    let id;
    try {
             

      await axios.post(`${url}/register`, {
        email,
        password,
        roleName: selectedRole,
        siteName: selectedSite,
      }).then((response) => { id = response.data.id })

      // await axios.post(`${BASEURL}/assignRoutes/${id}`, selectedSite === 'Kagal-Microgrid' ?
      //   { overview: kagalScreen.Overview, solar: kagalScreen.Solar, wind: kagalScreen.Wind, genset: kagalScreen.Genset, ess: kagalScreen.Ess, mains: kagalScreen.Mains, biogas: kagalScreen.Biogas, alert: kagalScreen.Alert }
      //   : { overview: cmklScreen.Overview, solar: cmklScreen.Solar, wind: cmklScreen.Wind, genset: cmklScreen.Genset, ess: cmklScreen.Ess, mains: cmklScreen.Mains, biogas: cmklScreen.Biogas, alert: cmklScreen.Alert })

      setMessage('Registration successful');
      setTimeout(() => {
        navigate('/', { replace: true });
      }, 1000);
    } catch (error) {
      if (error.response) {
        setError(error.response.data.message);
      } else {
        setError(error.message);
      }
    }
  };

  useEffect(() => {
    if (role === undefined) {
      setSelectedRole("Super-Admin")
    }
    else if (role === "Admin") {
      setSelectedRole("User");
    } else if (role === "Super-Admin") {
      setSelectedRole("Admin");
    } else {
      setSelectedRole("");
    }
  }, [role]);

  useEffect(() => {
    if (Array.isArray(site) && site.length === 1) {
      site.forEach((s) => {
        setSelectedSite(s.siteName);
      });
    }
  }, [site]);

  const handleChange_KAGAL = (event) => {
    // console.log('check', event.target)
    const { name, checked } = event.target;
    setKagalScreen((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };

  const handleChange_CMKL = (event) => {
    // console.log('check', event.target)
    const { name, checked } = event.target;
    setcmklScreen((prevData) => ({
      ...prevData,
      [name]: checked,
    }));
  };

  const handleKagalSelectAll = (event) => {
    const { checked } = event.target;
    const allSelected = Object.keys(kagalScreen).reduce((acc, key) => {
      acc[key] = checked;
      return acc;
    }, {});
    setKagalScreen(allSelected);
  };

  const handleCMKLSelectAll = (event) => {
    const { checked } = event.target;
    const allSelected = Object.keys(cmklScreen).reduce((acc, key) => {
      acc[key] = checked;
      return acc;
    }, {});
    setcmklScreen(allSelected);
  };
  return (
    <div className='relative flex flex-col justify-center items-center bg-gradient-to-t from-custom-dark-image to-custom-green-image h-screen'>
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded mt-4 w-2/4 absolute top-2 " role="alert">
          <strong className="font-bold">Error!</strong>
          <span className="block sm:inline pl-3">{error}</span>
          <span className="absolute top-0 bottom-0 right-0 px-3 py-2">
            <svg
              className="fill-current h-6 w-6 text-red-500"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              onClick={() => setError(null)} // Clear error on close
            >
              <title>Close</title>
              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
            </svg>
          </span>
        </div>
      )}
      <div className="w-full max-w-sm bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-extrabold text-center mb-6 text-custom-green-image">Register</h2>
        <div className="flex flex-col gap-4">
          <input
            type="email"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green-image"
          />
          <input
            type="password"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green-image"
          />
          <select
            onChange={(e) => setSelectedRole(e.target.value)}
            value={selectedRole}
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green-image"
          >
            {selectedRole === "" && <option value="">Select a role</option>}
            {selectedRole !== ""
              ? (
                <option value={selectedRole}>
                  {selectedRole}
                </option>
              ) : (
                roles.map((role) => (
                  <option key={role.id} value={role.role} className=''>
                    {role.role}
                  </option>
                ))
              )}
          </select>
          {site.length === 1 && <select
            onChange={(e) => setSelectedSite(e.target.value)}
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green-image"
          >
            {site.map((site) => (
              <option key={site.id} value={site.siteName}>
                {site.siteName}
              </option>
            ))}
          </select>}
          {site.length === 2 && <select
            onChange={(e) => setSelectedSite(e.target.value)}
            className="p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-green-image"
          >
            <option value="">Select a site</option>
            {site.map((site) => (
              <option key={site.id} value={site.siteName}>
                {site.siteName}
              </option>
            ))}
          </select>}
            
          {/* {selectedSite === 'Kagal-Microgrid'
            && <div className="grid grid-cols-2 gap-3">
              <label>
                <input
                  type="checkbox"
                  checked={Object.values(kagalScreen).every((value) => value === true)}
                  onChange={handleKagalSelectAll}
                  className="mr-2"
                />
                Select All
              </label>
              {Object.keys(kagalScreen).map((key) => (
                <div key={key} className="flex items-center space-x-2">
                  <label>
                    <input
                      type="checkbox"
                      name={key}
                      checked={kagalScreen[key] || false}
                      onChange={handleChange_KAGAL}
                      className="mr-2"
                    />
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                  </label>
                </div>
              ))}
            </div>}
          {selectedSite === 'CMKL-Microgrid' && <div className="grid grid-cols-2 gap-4">
            <label>
              <input
                type="checkbox"
                checked={Object.values(cmklScreen).every((value) => value === true)}
                onChange={handleCMKLSelectAll}
                className="mr-2"
              />
              Select All
            </label>
            {Object.keys(cmklScreen).map((key) => (
              <div key={key} className="flex items-center space-x-2">
                <label>
                  <input
                    type="checkbox"
                    name={key}
                    checked={cmklScreen[key]}
                    onChange={handleChange_CMKL}
                    className="mr-2"
                  />
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </label>
              </div>
            ))}
          </div>} */}

          <button
            onClick={handleRegister}
            className="bg-gradient-to-t from-custom-dark-image to-custom-green-image text-white font-bold py-2 px-4 rounded-lg transition duration-300"
          >
            Register
          </button>
        </div>
      </div>
      {message && (
        <div className="bg-green-200 border border-green-300 text-green-800 px-3 py-2 rounded mt-4 w-2/4 absolute bottom-10 " role="alert">
          <strong className="font-bold">Message!</strong>
          <span className="block sm:inline pl-3">{message}</span>
          <span className="absolute top-0 bottom-0 right-0 px-3 py-2">
            <svg
              className="fill-current h-6 w-6 text-green-800"
              role="button"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              onClick={() => setMessage(null)} // Clear error on close
            >
              <title>Close</title>
              <path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" />
            </svg>
          </span>
        </div>
      )}
    </div>
  );
}

export default Register;
